import { graphql } from '@/gql/client';

export const ServiceFieldsFragment = graphql(`
  fragment ServiceFieldsFragment on Service {
    ...ServiceSummaryFieldsFragment
    content
    seo {
      ...PostTypeSeoFieldsFragment
    }
    pageCustomFields {
      sidetext {
        text
        placement
      }
      enableOverlayNavbar
      enableLines
      theme
      hideFooterDivider
      hideSidetext
    }
  }
`);
